// noinspection SpellCheckingInspection

import {logError} from '../fingerprint.js';
import normalizeData from './normalizeData.js';
import stableHash from './stableHash.js';


async function getWebGPU() {
    // Проверяем поддержку WebGPU в браузере
    if (!navigator.gpu) {
        return null;
    }

    try {
        // Получаем адаптер GPU (отвечает за взаимодействие с графическим процессором)
        const adapter = await navigator.gpu.requestAdapter();
        if (!adapter) {
            return null;
        }
        // Запрашиваем устройство GPU (необходимо для выполнения вычислений)
        //const device = await adapter.requestDevice();

        // Собираем список поддерживаемых функций (например, тесселяция, текстуры и т.д.)
        const features = adapter.features ? Array.from(adapter.features) : [];
        const WEBGPU_FEATURES = normalizeData(features);
        const WEBGPU_FEATURES_HASH = stableHash(WEBGPU_FEATURES.join(','));
        const limits = {};
        for (const limit in adapter.limits) {
            // Сохраняем numeric лимиты адаптера как есть.
            limits[limit] = adapter.limits[limit];
        }

        // Собираем всю информацию в один объект
        return {
            // Производитель GPU (например, "Apple", "NVIDIA"), может быть ограничено браузером
            WEBGPU_VENDOR: adapter.info?.vendor || null,
            // Архитектура GPU (например, "M1", "RTX 3090"), может быть ограничено браузером
            WEBGPU_ARCHITECTURE: adapter.info?.architecture || null,
            // ограничения gpu
            WEBGPU_LIMITS: limits,
            WEBGPU_FEATURES, // Список поддерживаемых возможностей GPU
            WEBGPU_FEATURES_HASH, // Хеш списка поддерживаемых возможностей GPU
            WEBGPU_COMPUTEPERFORMANCE: null,
            WEBGPU_FREQUENCYSTABILITY: null,
            WEBGPU_CACHEPROFILE: null,
        };
    } catch (error) {
        logError(error);
        return null;
    }
}

export default getWebGPU;
